import { hasKeysOfUnknown, isDefined, isObject } from 'common/helpers'
import type { GltfData, GltfExtras, GltfLegend, LegendGltf } from 'common/types'

function isGltfData(data: unknown): data is GltfData {
  return isObject(data) && 'extras' in data && isObject(data.extras) && isGltfExtras(data.extras)
}

function isGltfExtras(extras: object): extras is GltfExtras {
  return 'Legend' in extras && isObject(extras.Legend) && isGltfLegend(extras.Legend)
}

function isGltfLegend(legend: object): legend is GltfLegend {
  return (
    'Start' in legend &&
    'Stop' in legend &&
    typeof legend.Stop === 'number' &&
    typeof legend.Start === 'number'
  )
}

export function isGltfWithLegend(data: unknown): asserts data is LegendGltf {
  if (
    isObject(data) &&
    hasKeysOfUnknown(data, 'nodes') &&
    isDefined(data.nodes) &&
    Array.isArray(data.nodes) &&
    isGltfData(data.nodes[0])
  ) {
    return
  }

  throw new Error('data не является типом LegendGltf')
}
